module.exports = __webpack_public_path__ + "media/images/front/materials/piedra-e50ca39d1472b9ecec01ff494bff33f6.jpg";